import React from 'react';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
import { PremiumCTAButton } from './ui/PremiumCTAButton';
export function FinalCTA() {
  return <section className="py-24 bg-black relative overflow-hidden" data-id="element-160">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold-500/10 rounded-full blur-[120px]" data-id="element-161"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-162">
        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-163">
          Si tu estrés viene de tener <br data-id="element-164" />
          <span className="text-gradient-gold" data-id="element-165">demasiado abierto...</span>
        </h2>

        <p className="text-2xl text-gray-300 mb-8" data-id="element-166">
          No necesitas más horas.{' '}
          <span className="text-white font-semibold" data-id="element-167">Necesitas cerrar.</span>
        </p>

        <div className="bg-dark-900 border border-gold-500/20 rounded-2xl p-8 mb-10 max-w-2xl mx-auto" data-id="element-168">
          <p className="text-3xl font-serif text-gold-500 mb-2" data-id="element-169">Un bloque.</p>
          <p className="text-3xl font-serif text-gold-500 mb-2" data-id="element-170">Una tarea.</p>
          <p className="text-3xl font-serif text-gold-500 mb-4" data-id="element-171">Un cierre.</p>
          <p className="text-lg text-gray-400" data-id="element-172">
            Hazlo visible. Y el ruido baja.
          </p>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-173">
          <PremiumCTAButton size="xl" className="w-full md:w-auto" data-id="element-174" />

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mt-4" data-id="element-175">
            <div className="flex items-center gap-2" data-id="element-176">
              <Lock className="w-4 h-4 text-gold-500" data-id="element-177" />
              <span data-id="element-178">Pago Seguro SSL</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-179">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-180" />
              <span data-id="element-181">Garantía de 30 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-182">
              <Zap className="w-4 h-4 text-gold-500" data-id="element-183" />
              <span data-id="element-184">Acceso Instantáneo</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}